import { render, staticRenderFns } from "./accessibility.vue?vue&type=template&id=75bbbc29&scoped=true&"
import script from "./accessibility.vue?vue&type=script&lang=js&"
export * from "./accessibility.vue?vue&type=script&lang=js&"
import style0 from "./accessibility.vue?vue&type=style&index=0&id=75bbbc29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbbc29",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProjectForm: require('/builds/knockmedia/knock-vi-web/src/components/ProjectForm.vue').default})
